
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround3 as ObiGround3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-3.js';
 
 
 

 
 export const ObiGround3 = createComponent({
   react: React,
   tagName: 'obi-ground-3',
   elementClass: ObiGround3Element,
   events: {
     
   }
  });
 
 